import { ref, watchEffect } from 'vue';

/**
 * Composable pour récupérer l'ID Wistia depuis une URL
 * @param {Ref|string} url - URL Wistia ou ref vers une URL
 * @returns {Ref} - ID de la vidéo (null si non trouvé)
 */
export const useWistiaId = (url) => {
    const videoId = ref(null);

    // Fonction pour extraire l'ID
    const extractId = (val) => {
        if (!val) return null
        const cleanUrl = val.split(/[?#]/)[0]
        const match = cleanUrl.match(/\/medias\/([^\/]+)$/)
        return match ? match[1] : null
    };

    // Si url est une ref reactive, recalculer automatiquement
    watchEffect(() => {
        videoId.value = typeof url === 'string' ? extractId(url) : extractId(url.value);
    });

    return videoId;
};
